module.exports = __webpack_public_path__ + "static/img/accountmanagement2.55eabd4b.png";